$tablet-breakpoint: 840px;
$mobile-breakpoint: 480px;

@mixin centered-container {
  max-width: 1440px;
  padding: 0 104px;
  margin: 0 auto;

  @media only screen and (max-width: $tablet-breakpoint) {
    padding: 0 48px;
  }

  @media only screen and (max-width: $mobile-breakpoint) {
    padding: 0 16px;
  }
}

.top-level-header-container {
  padding: 0.4rem 0;
  box-shadow: 0 0.8rem 2.4rem #dcdce1;

  & > * {
    @include centered-container;
  }
}

.top-level-layout-container {
  @include centered-container;

  &__page-content {
    display: flex;

    @media only screen and (max-width: $tablet-breakpoint) {
      flex-direction: column;
    }

    &__left-side-content {
      flex: 0 1 800px;
      margin-right: 3.2rem;
      min-width: 0;

      @media only screen and (max-width: $tablet-breakpoint) {
        flex: 0 0 auto;
        margin-right: 0;
      }
    }

    &__right-side-content {
      flex: 0 1 400px;

      @media only screen and (max-width: $tablet-breakpoint) {
        flex: 0 0 auto;
      }
    }
  }
}
